import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardName from "../../../components/global/CardName";
import Widget from "../../../components/card/widget/Widget";
import CardProject from "../../../components/card/project/CardProject";
import WidgetModalAdd from "../../../components/card/widget/WidgetAddModal";
import ModalRemove from "./ModalRemove";
import ModalComplete from "./ModalComplete";
import ModalCompleteCancel from "./ModalCompleteCancel";
import CardUser from "../../../components/card/CardUser";
import WidgetAddFavorite from "../../../components/card/widget/WidgetAddFavorite";
import axios from "axios";
import ButtonAction from "../../../components/global/ButtonAction";
import { listClear as clearWidget } from '../../../reducers/models/widgetData';
import WidgetItemPriority from "../../../components/card/widget/WidgetItemPriority";
import WidgetItemDeadlines from "../../../components/card/widget/WidgetItemDeadlines";
import WidgetItemLabel from "../../../components/card/widget/WidgetItemLabel";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalUpdate({ show, onHide, idTask, calendar }) {

    const id_object = 1;

    const dispatch = useDispatch()

    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки
    const [hightBody, setHightBody] = useState(0);

    const stateSize = useSelector((state) => state.size);//Размеры окна
    const stateWidgetData = useSelector((state) => state.widgetData);//Данные для виджета
    const stateList = useSelector((state) => state.taskList);//Редюсер задач

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingUser, setLoadingUser] = useState(false);

    const [widgetModalShow, setWidgetModalShow] = useState(false);
    const [widgetEditing, setWidgetEditing] = useState(false);

    const [formIdUser, setFormIdUser] = useState(null);
    const [formName, setFormName] = useState(null);
    const [formIdType, setFormIdType] = useState(1);//Выполнят один из ответственных
    const [formIdProject, setFormIdProject] = useState(null);
    const [formIdStatus, setFormIdStatus] = useState(null);//0-Черновик; 1-В работе; 2-Выполнена
    const [formIdTab, setFormIdTab] = useState(null);
    const [modalRemoveShow, setModalRemoveShow] = useState(false);
    const [modalCompleteShow, setModalCompleteShow] = useState(false);
    const [modalCompleteCancelShow, setModalCompleteCancelShow] = useState(false);

    useEffect(() => {
        if (refHeader.current !== undefined & refFooter.current !== undefined & stateSize.desktop !== true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 70)
        }
        if (refHeader.current !== undefined & stateSize.desktop === true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 100)
        }
    }, [refHeader, refFooter, stateSize, formName, loadingUser, stateWidgetData]);


    useEffect(() => {

        if (stateList.list.filter(a => a.ID === idTask).length > 0) {
            const model = stateList.list.filter(a => a.ID === idTask)[0];

            setFormName(model.Name);
            setFormIdType(model.ID_Type);
            setFormIdProject(model.ID_Project);
            setFormIdStatus(model.ID_Status);
            setFormIdUser(model.ID_User);
            setFormIdTab(model.id_tab)
            //widgetLoad(idTask);//Подгрузка Widget
        }

    }, [idTask, stateList.list]);

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);

    //Добавит/Обновит задачу
    function updateName(name) {
        setLogName(null);
        setLoadingName(true);

        if (name === null) {
            setLog('Введите название задачи');
            setLoadingName(false);
        }
        else {
            axios.post('/api_tracker/task/updateName', { ID_Task: idTask, Name: name })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setHideName(true);
                        setLoadingName(false);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoadingName(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoadingName(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    //Изменит тип задачи
    function updateTypeHandler(idType) {
        setLoading(true);

        axios.post('/api_tracker/task/updateType', { ID_Task: idTask, ID_Type: idType })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    /********************************START ПРОЕКТ***********************************/
    const [logProject, setLogProject] = useState(null);
    const [loadingProject, setLoadingProject] = useState(null);
    const [hideModalProject, setHideModalProject] = useState(false);

    function updateProjectHandler(id) {
        setLogProject(null);
        setLoadingProject(true);
        setHideModalProject(false);

        axios.post('/api_tracker/task/updateProject', { ID_Task: idTask, ID_Project: id })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormIdProject(id);
                    setHideModalProject(true);
                    setLoadingProject(false);
                }
                else {
                    setLogProject(res.data.Error);
                    setLoadingProject(false);
                }
            })
            .catch((err) => {
                setLogProject('Неизвестная ошибка!');
                setLoadingProject(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /*********************************END ПРОЕКТ************************************/
    /***************************START ИЗМЕНЕНИЕ СТАТУСА*****************************/
    const [logStatus, setLogStatus] = useState(null);

    //В работу
    function statusWorkHandler() {
        axios.post('/api_tracker/task/statusWork', { ID_Task: idTask })
            .then((res) => {
                if (res.data.Status === 1) {
                    onHide();
                }
                else {
                    setLogStatus(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLogStatus('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /****************************END ИЗМЕНЕНИЕ СТАТУСА******************************/
    /********************************START WIDGET***********************************/
    const [addedWidget, setAddedWidjet] = useState(null);
    function widgetAddHandler(obj) {
        setAddedWidjet(obj);
    }

    function widgetMenuHandler(id_menu) {
        //id_menu: 1-Добавление; 2-Редактирование
        if (id_menu === 1) {
            setWidgetModalShow(true);
        }
        if (id_menu === 2) {
            setWidgetEditing(!widgetEditing)
        }
    }
    /*********************************END WIDGET************************************/

    //Событие при  закрытии модального окна
    function eventModalClose() {
        //ОЧИЩАЕМ ФОРМУ          
        setFormName(null);
        setLoading(false);
        setLoadingProject(false);
        setLoadingUser(false);
        setLog(null);
        dispatch(clearWidget());//Очищаем виджеты
        onHide();
    }

    return (
        <>
            {stateSize.desktop === true ? (
                <Modal show={show} onHide={() => eventModalClose()} size="lg">
                    <Modal.Body >
                        <div className="modal_close" onClick={() => eventModalClose()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="row" >
                            <div className="col-md-8" >
                                <div ref={refHeader}>
                                    <div>
                                        <CardName name={formName} updateHandler={updateName} onlyRead={formIdStatus === 2 ? true : false} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div>
                                            <CardProject idTask={idTask} idProject={formIdProject} idObject={id_object} idSelected={formIdProject} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={formIdStatus === 2 ? true : false} />
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                                <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="mt-5">
                                        <div>
                                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 1).length > 0 && (
                                                <WidgetItemDeadlines idObject={id_object} idWidget={1} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 1)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />)}
                                        </div>
                                    </div>
                                    {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                        <WidgetItemLabel idTab={calendar === true ? -1 : formIdTab} idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />)}
                                </div>
                                <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody, overflow: 'auto' }}>
                                    <Widget idTab={calendar === true ? -1 : formIdTab} idObject={id_object} idItem={idTask} editMode={widgetEditing} idProject={formIdProject} onlyRead={formIdStatus === 2 ? true : false} addedWidget={addedWidget} />
                                </div>
                            </div>
                            <div className="col-md-4" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 100, overflow: 'auto' }}>
                                <div className="card-block-title">Действия</div>
                                <>
                                    {formIdStatus === 0 && (
                                        //Черновик
                                        <>

                                            <div><ButtonAction typeBtn='work' onClick={() => statusWorkHandler()} /></div>
                                            <div className='mt-5'><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                        </>

                                    )}
                                    {formIdStatus === 1 && (
                                        //В работе
                                        //model.Completed_Myself !== true &&

                                        //Сам не завершал
                                        <div><ButtonAction typeBtn='finish' onClick={() => setModalCompleteShow(true)} /></div>
                                    )}
                                    {formIdStatus === 2 && (
                                        //Выполнена
                                        <>
                                            <div><ButtonAction typeBtn='cancel' onClick={() => setModalCompleteCancelShow(true)} textBtn="Отменить" /></div>
                                        </>
                                    )}

                                    {logStatus !== null && <div className="form_error text-center mt-15">{logStatus}</div>}
                                </>
                                <div className="card-block-title">Ответственные</div>
                                <CardUser idItem={idTask} idProject={formIdProject} idObject={id_object} idType={formIdType} typeChangeHandler={updateTypeHandler} onlyRead={formIdStatus === 2 ? true : false} />

                                {formIdStatus !== 2 && (
                                    <WidgetAddFavorite id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                                )}
                            </div>
                        </div>
                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    </Modal.Body>
                </Modal >
            ) : (
                <Modal show={show} onHide={() => eventModalClose()} size="lg">
                    <Modal.Body >
                        <div ref={refHeader}>
                            <div style={{ display: 'flex' }}>
                                <CardName name={formName} updateHandler={updateName} setName={setFormName} onlyRead={formIdStatus === 2 ? true : false} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                <div className="modal_close" style={{ marginLeft: 'auto' }} onClick={() => eventModalClose()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            </div>
                            <CardProject idTask={idTask} idProject={formIdProject} idObject={id_object} idSelected={formIdProject} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={formIdStatus === 2 ? true : false} />

                            <div className="mt-5" style={{ display: 'flex' }}>
                                <div>
                                    {stateWidgetData.listStandart.filter(a => a.ID_Widget === 1).length > 0 && (
                                        <WidgetItemDeadlines idObject={id_object} idWidget={1} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 1)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />)}
                                </div>
                                <div style={{ marginLeft: 'auto' }}>
                                    {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                        <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />
                                    )}
                                </div>
                            </div>
                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                <WidgetItemLabel idTab={calendar === true ? -1 : formIdTab} idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={idTask} onlyRead={false} added={addedWidget} />
                            )}
                        </div>
                        <div key={hightBody} style={{ maxHeight: hightBody, overflow: 'auto' }}>
                            <Widget idTab={calendar === true ? -1 : formIdTab} idObject={id_object} idItem={idTask} editMode={widgetEditing} idProject={formIdProject} onlyRead={formIdStatus === 2 ? true : false} addedWidget={addedWidget} />
                        </div>
                        <div ref={refFooter}>
                            <hr></hr>
                            <CardUser idItem={idTask} idObject={id_object} idProject={formIdProject} idType={formIdType} typeChangeHandler={updateTypeHandler} onlyRead={formIdStatus === 2 ? true : false} loading={loadingUser} setLoading={setLoadingUser} />
                            <hr></hr>
                            <div style={{ height: '55px' }}>
                                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                <div className="m_btn_block_footer">
                                    {formIdStatus === 0 && (
                                        //Черновик  
                                        <>
                                            <div><ButtonAction typeBtn='work' onClick={() => statusWorkHandler()} /></div>
                                            <div><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                        </>
                                    )}
                                    {formIdStatus === 1 && (
                                        //В работе
                                        //model.Completed_Myself !== true &&
                                        //Сам не завершал
                                        <div><ButtonAction typeBtn='finish' onClick={() => setModalCompleteShow(true)} /></div>
                                    )}
                                    {formIdStatus === 2 && (
                                        //Выполнена 
                                        <div><ButtonAction typeBtn='cancel' textBtn="Отменить" onClick={() => setModalCompleteCancelShow(true)} /></div>
                                    )}
                                    {formIdStatus !== 2 && (
                                        <WidgetAddFavorite id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body >
                </Modal >
            )
            }
            {
                modalRemoveShow === true && (
                    <ModalRemove idTask={idTask} name={formName} show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} onHideTask={onHide} />
                )
            }
            {
                modalCompleteShow === true && (
                    <ModalComplete idTask={idTask} idUser={formIdUser} name={formName} show={modalCompleteShow} onHide={() => setModalCompleteShow(false)} onHideTask={onHide} />
                )
            }
            {
                modalCompleteCancelShow === true && (
                    <ModalCompleteCancel idTask={idTask} idUser={formIdUser} name={formName} show={modalCompleteCancelShow} onHide={() => setModalCompleteCancelShow(false)} onHideTask={onHide} />
                )
            }
            {
                widgetModalShow === true && (
                    <WidgetModalAdd id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} />
                )
            }
        </>
    );
}
export default ModalUpdate;
